var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`drawer-right-wrapper`,style:({
        width: _vm.drawerVisible ? _vm.isSmall ? '100%' : `${_vm.size}px` : '0',
      })},[_vm._t("drawer-content")],2),_c('div',{staticClass:"drawer-mask",style:({
      width: _vm.drawerVisible ? '100vw' : '0',
      opacity: _vm.drawerVisible ? '0' : '0',
    }),on:{"click":() => _vm.closeDrawer()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }